import axios from 'axios'
import router from "@/router";
import {serverIp} from "../../public/config";
import ElementUI from "element-ui";
import requestDB from "@/utils/requestDB";

function redirectToIpApply(data) {
    if (!data || data.code !== 'IP_NOT_ALLOWED') {
        return false
    }
    const query = {}
    if (data.data && data.data.ip) {
        query.ip = data.data.ip
    }
    if (data.data && data.data.username) {
        query.username = data.data.username
    }
    ElementUI.Message({
        message: data.msg || '当前IP未在白名单，请提交登录IP申请',
        type: 'warning'
    });
    if (router.currentRoute.path !== '/ip-apply') {
        router.push({ path: '/ip-apply', query })
    }
    return true
}

const request = axios.create({
    baseURL: serverIp.startsWith("localhost") ? `http://${serverIp}/back` : `https://${serverIp}/back`,
    timeout: 100000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
    config.headers['Content-Type'] = 'application/json;charset=utf-8';
    let user = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : null
    if (user) {
        config.headers['token'] = user.token;  // 设置请求头
    }

    return config
}, error => {
    return Promise.reject(error)
});

// response 拦截器
request.getErrorCode = function (error) {
    if (!error.response) {
        console.log("error", error.message)
        return;
    }
    let data = error.response.data
    if (typeof data === 'string') {
        try {
            data = data ? JSON.parse(data) : data
        } catch (e) {
            data = null
        }
    }
    if (redirectToIpApply(data)) {
        return;
    }
    if (data && data.code === 'IP_BLOCKED') {
        ElementUI.Message({
            message: data.msg || '当前IP已被阻断，请联系管理员',
            type: 'error'
        });
        return;
    }
    switch (error.response.status) {
        case 401:
            ElementUI.Message({
                message: (data && data.msg) || error.response.statusText,
                type: 'error'
            });
            //router.push("/front/home")
            router.push("login")
            return;
        //其他错误码
        default:
            console.log("error", error.response.statusText)
            return;
    }
};
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 如果是返回的文件
        if (response.config.responseType === 'blob') {
            return res
        }
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            res = res ? JSON.parse(res) : res
        }
        if (redirectToIpApply(res)) {
            return res
        }
        if (res.code === 'IP_BLOCKED') {
            ElementUI.Message({
                message: res.msg || '当前IP已被阻断，请联系管理员',
                type: 'error'
            });
            return res
        }
        // 当权限验证不通过的时候给出提示
        if (res.code === '401') {
            ElementUI.Message({
                message: res.msg,
                type: 'error'
            });
            //router.push("/front/home")
            router.push("login")
        }
        return res;
    },
    error => {
        //获取错误码
        request.getErrorCode(error)
        return Promise.reject(error)
    }
)


export default request

